const INVOICE_NUMBER_PAD_LENGTH = 4;

const toInvoiceString = (value) => {
  if (value === null || value === undefined) return '';
  return value.toString().trim();
};

const getInvoiceNumberDigits = (value) => {
  const invoiceNo = toInvoiceString(value);
  if (!invoiceNo) return '';

  const trailingDigits = invoiceNo.match(/(\d+)\s*$/);
  return trailingDigits ? trailingDigits[1] : '';
};

const padInvoiceNumber = (value) => {
  const digits = toInvoiceString(value);
  if (!digits) return '';
  return digits.padStart(INVOICE_NUMBER_PAD_LENGTH, '0');
};

const getNormalizedInvoiceNumber = (value) => {
  const invoiceNo = toInvoiceString(value);
  if (!invoiceNo) return '';

  const digits = getInvoiceNumberDigits(invoiceNo);
  return digits ? padInvoiceNumber(digits) : invoiceNo.toLowerCase();
};

export const formatInvoiceNumber = (value) => {
  const invoiceNo = toInvoiceString(value);
  if (!invoiceNo) return '';

  if (/^\d+$/.test(invoiceNo)) {
    return padInvoiceNumber(invoiceNo);
  }

  const digits = getInvoiceNumberDigits(invoiceNo);
  return digits ? padInvoiceNumber(digits) : invoiceNo;
};

export const getInvoiceNumberLabel = (value) => formatInvoiceNumber(value);

export const matchesInvoiceNumberQuery = (invoiceNo, query) => {
  const normalizedQuery = toInvoiceString(query).toLowerCase();
  if (!normalizedQuery) return true;

  const rawInvoiceNo = toInvoiceString(invoiceNo).toLowerCase();
  const displayInvoiceNo = getInvoiceNumberLabel(invoiceNo).toLowerCase();

  return rawInvoiceNo.includes(normalizedQuery) || displayInvoiceNo.includes(normalizedQuery);
};

export const resolveInvoiceNumber = (value, options = [], getOptionValue = (option) => option?.inv_no ?? option) => {
  const invoiceNo = toInvoiceString(value);
  if (!invoiceNo) return '';

  const normalizedInvoiceNo = invoiceNo.toLowerCase();
  const comparableInvoiceNo = getNormalizedInvoiceNumber(invoiceNo);
  const matchingOption = options.find((option) => {
    const optionValue = toInvoiceString(getOptionValue(option));
    if (!optionValue) return false;

    return (
      optionValue.toLowerCase() === normalizedInvoiceNo ||
      getInvoiceNumberLabel(optionValue).toLowerCase() === normalizedInvoiceNo ||
      getNormalizedInvoiceNumber(optionValue) === comparableInvoiceNo
    );
  });

  return matchingOption ? toInvoiceString(getOptionValue(matchingOption)) : invoiceNo;
};
